import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-customer-invoicing',
  templateUrl: './customer-invoicing.component.html',
  styleUrls: ['./customer-invoicing.component.css']
})
export class CustomerInvoicingComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public grid?: GridOptions;

    public creatingInvoice = false;

    public settingNotInvoice = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2191, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.setting.view_id).setLoadDataFunction({ method: this.setting.p2_datatask_keyno, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async createChanges() {
        if (!!this.setting) {
            try {
                this.creatingInvoice = true;

                const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({
                    powtime_keyno: row['powtime_keyno'],
                    is_selected: row['is_selected']
                }));

                const mergeObj = {
                    ...this.setting,
                    records: selectedItems
                }

                const response = (await this.datatask.Post(2193, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.creatingInvoice = false;
            }
        }
    }

    public async setNotChanges() {
        if (!!this.setting) {
            try {
                this.settingNotInvoice = true;

                const selectedItems = (this.grid?.gridfunc?.getAllRows() ?? []).filter((row) => row['is_selected'] === true).map((row) => ({
                    powtime_keyno: row['powtime_keyno'],
                    is_selected: row['is_selected']
                }));

                const mergeObj = {
                    ...this.setting,
                    records: selectedItems
                }

                const response = (await this.datatask.Post(2202, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.settingNotInvoice = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    businessco_no: string;
    businessco_companyname: string;
    invoice_cust_no: string;
    cust_name: string;
    view_id: string;
    p2_datatask_keyno: number;
    invoice_date: string;
}
